import axios from "../../../config/axiosInstance";
import { API } from "../../../config/API";
import { notification } from "antd";
import { POST } from "../../../utils/apirequest";

const CreateNews = (values: any, body: any, editorID: any) => {
  const tagsfilteredArray = values?.tags?.join("|");
  const selectedCategories = values?.categories?.map((value: any) =>
    JSON.parse(value)
  );

  let categories = selectedCategories?.map((item: any) => {
    return item.id;
  });

  let CatArray = selectedCategories
    ?.map((item: any) => "%" + item?.category?.toLowerCase())
    .join("");
  let show;
  if (body?.onlive === true && values?.Show === undefined) {
    show = true;
  }
  let requestObj = {
    data: {
      title: body.blurb,
      head: values?.head,
      body: body.body,
      image: body.image,
      image2: body.image2,
      social_image: body.social_image,
      categories: categories,
      Subcategories: values.subcategory,
      tagsArray: CatArray,
      newsTag: tagsfilteredArray,
      publishedAt: body.publishedAt,
      audio: body.audio ? body.audio : null,
      user: body?.user,
      onlive: values?.Show === true ? values.Show : show || false,
      isHighPriority: values?.isHighPriority === 1 ? true : false,
      isSecondLeads: values?.isHighPriority === 2 ? true : false,
      permalink: values?.permalink,
      editing_Status: false,
      liveEditingUser: "null",
      image1_description: body?.image1_description,
      image2_description: body?.image2_description,
      image1_caption: body?.image1_caption,
      author_name: values?.author_name,
      author_image: body.author_image ? body.author_image : null,
      scheduled_at: body?.scheduled_at ? body.scheduled_at : null,
      social_embed: body?.social_embed || null,
      embed_type: body?.embed_type || null,
    },
  };

  let id = body.id;
  let url = id
    ? API.BASE_URL + API.UPDATE_NEWS + `/${id}/${editorID}`
    : API.BASE_URL + API.CREATENEWS;

  const request = id
    ? axios.put(url, requestObj)
    : axios.post(url, requestObj);

  return request
    .then((response) => {
      notification.success({ message: `News ${values.type}` });
      addTags(values?.tags);
      return response.data;
    })
    .catch((error) => {
      notification.error({ message: error?.message || "Failed to save news" });
      throw error;
    });
};

const getNewsById = (url: any) => {
  return axios.get(url).then((response) => response);
};

const EditNews = (id: any, body: any) => {
  let url = API.BASE_URL + API.ALL_NEWS + `/${id}`;
  return axios.put(url, body).then((response) => response.data);
};

const PublishNews = (id: any) => {
  let url = API.BASE_URL + API.PUBLISH_NEWS + `/${id}`;
  return axios.put(url).then((response) => response.data);
};

const SaveDraft = (id: any, data: any) => {
  let url = id
    ? API.BASE_URL + API.ALL_NEWS + `/${id}`
    : API.BASE_URL + API.CREATENEWS;

  if (!id) {
    setTimeout(() => {
      axios.post(url, data).catch((error) => console.log(error));
    }, 2000);
  } else {
    console.log("updating logic");
  }
};

const addTags = async (val: any) => {
  try {
    let url = API.TAGS_ADD;
    let body = { tags: val };
    await POST(url, body);
  } catch (error) {
    console.log("error", error);
  }
};

export { CreateNews, EditNews, PublishNews, SaveDraft, addTags, getNewsById };
